import { SubscanAccount } from 'services/subscan';

const TREASURY_ORIGIN = 'treasury';

export enum TreasuryProposalStatus {
  Proposed = 'proposed',
  Awarded = 'awarded',
  Rejected = 'rejected',
  Approved = 'approved',
  MotionAt = 'motionAt',
}

type TreasuryTimeline = {
  block: number;
  status: string;
  time: number;
  prophecy: boolean;
  index: number;
  extrinsic_index: string;
};

type Council = {
  proposalId: number;
  ayeVotes: number;
  createdBlock: number;
  memberCount: number;
  nayVotes: number;
  proposal_hash: string;
  proposer: SubscanAccount;
  status: string;
  updatedBlock: number;
};

interface TreasuryProposalConstructorParams {
  id: string;
  index: number;
  origin: string;
  moonChainKey?: string;
  active: boolean;
  status: TreasuryProposalStatus;
  title?: string;
  description?: string;
  subscanTitle?: string;
  subscanDescription?: string;
  bond?: string;
  createdBlock?: number;
  symbol: string;
  reward?: string;
  beneficiary: SubscanAccount;
  proposer?: SubscanAccount | null;
  historicalPrice?: string;
  timeline?: TreasuryTimeline[];
  forumLink?: string;
  links?: string[];
  updatedAt?: number;
  createdAt?: number;
  statusUpdatedAt: number;
  proposeTime?: number;
  council?: Council;
}

export class TreasuryProposal {
  readonly id: string;
  readonly index: number;
  readonly origin: string;
  readonly moonChainKey?: string;
  readonly active: boolean;
  readonly status: TreasuryProposalStatus;
  readonly title?: string;
  readonly description?: string;
  readonly subscanTitle?: string;
  readonly subscanDescription?: string;
  readonly bond?: string;
  readonly createdBlock?: number;
  readonly symbol: string;
  readonly reward?: string;
  readonly beneficiary: SubscanAccount;
  readonly proposer?: SubscanAccount | null;
  readonly historicalPrice?: string;
  readonly timeline?: TreasuryTimeline[];
  readonly forumLink?: string;
  readonly links?: string[];
  readonly updatedAt?: number;
  readonly createdAt?: number;
  readonly statusUpdatedAt: number;
  readonly proposeTime?: number;
  readonly council?: Council;

  constructor(params: TreasuryProposalConstructorParams) {
    this.id = params.id;
    this.index = params.index;
    this.origin = params.origin;
    this.moonChainKey = params.moonChainKey;
    this.active = params.active;
    this.status = params.status;
    this.title = params.title;
    this.description = params.description;
    this.subscanTitle = params.subscanTitle;
    this.subscanDescription = params.subscanDescription;
    this.bond = params.bond;
    this.createdBlock = params.createdBlock;
    this.symbol = params.symbol;
    this.reward = params.reward;
    this.beneficiary = params.beneficiary;
    this.proposer = params.proposer;
    this.historicalPrice = params.historicalPrice;
    this.timeline = params.timeline;
    this.forumLink = params.forumLink;
    this.links = params.links;
    this.updatedAt = params.updatedAt;
    this.createdAt = params.createdAt;
    this.statusUpdatedAt = params.statusUpdatedAt;
    this.proposeTime = params.proposeTime;
    if (params.council) this.council = params.council;
  }

  public static isInstance(obj: unknown): obj is TreasuryProposal {
    if (!obj || typeof obj !== 'object') {
      return false;
    }

    return (
      obj instanceof TreasuryProposal ||
      ('origin' in obj && obj?.origin === TREASURY_ORIGIN)
    );
  }
}
